import './lib/jquery'

function removeSpinner() {
  $('#overlay').css({ display: 'none' })
  $('body').css({ 'overflow-y': 'none' })
}

function showSpinner() {
  window.scrollTo(0, 0)
  $('#overlay').css({ display: 'block' })
  $('body').css({ 'overflow-y': 'hidden' })
}

document.addEventListener('DOMContentLoaded', () => {
  removeSpinner()

  const buttonList = document.getElementsByClassName('show-spinner')

  Array.from(buttonList).forEach((button) => {
    button.addEventListener('click', function (event) {
      if ($(this).attr('data-confirm-spinner')) {
        // eslint-disable-next-line no-restricted-globals, no-alert
        if (confirm($(this).attr('data-confirm-spinner'))) {
          showSpinner()
        } else {
          removeSpinner()
          event.preventDefault()
        }
      } else {
        showSpinner()
      }
    })
  })
})
